export default {
  title: {
    id: 'bo_seller-options-shipping-quality_charter-title',
    defaultMessage: 'Get Quality Charter-approved ✔️',
  },
  subtitle: {
    id: 'bo_seller-options-shipping-quality_charter-subtitle',
    defaultMessage:
      'We took the guesswork out of shipping for you. Any rules you create will already be Quality Charter-approved.',
  },
  tellMeMore: {
    id: 'bo_seller-options-shipping-quality_charter-tell_me_more',
    defaultMessage: 'Tell me more',
  },
} as const
